import React from 'react';
import ReactDOM from 'react-dom';
import AppRouter from './AppRouter';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from 'react-oidc-context';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { WebStorageStateStore } from 'oidc-client-ts';
import AuthWrapper from './components/Auth/AuthWrapper';

// Initialize axios interceptors for 403 handling
import './utils/axiosConfig';

const cognitoAuthConfig = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI,
  response_type: 'code',
  scope: 'phone openid email profile',
  post_logout_redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  stateStore: new WebStorageStateStore({ store: window.localStorage }),
};

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <Provider store={store}>
        <AuthWrapper>
          <AppRouter />
        </AuthWrapper>
      </Provider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
